import { FullContainer } from '@gorila-shared-ui/components';
import { AsideLayout } from '../../layout/AsideLayout';
import AllSubAccountsProvider from '../../providers/AllSubAccountsProvider';
import UsersProvider from '../../providers/UsersProvider';
import { UserDetail } from './UserDetail';
import { UserList } from './UserList';

export function UsersTab() {
  return (
    <FullContainer flexible>
      <AllSubAccountsProvider />
      <UsersProvider />
      <AsideLayout aside={<UserList />}>
        <UserDetail />
      </AsideLayout>
    </FullContainer>
  );
}
